<template>
  <div class="mb-4 p-3 border rounded-3 bg-light">
    <h1 class="mb-3">{{ $t("clientes.busqueda_contacto_lead.titulo") }}</h1>
    <div class="d-flex flex-wrap align-items-center gap-2">
      <DxTextBox v-model="movilDisplay" :mask="'+34 000 000 000'" mask-char="_" :mask-invalid-message="intl.i18n.t('wizard.step4.validacion.telefono_patron')"
        :use-masked-value="true" :show-clear-button="true" />
        
      <DxButton v-bind="{...secondaryButtonProps($t('clientes.busqueda_contacto_lead.buscar')), icon: 'fa-solid fa-search'}" @click="buscar" />
      <span v-if="resultadoBusqueda === true" class="d-inline-flex align-items-center gap-2 text-success">
        <i class="fa-solid fa-check" aria-hidden="true"></i>
        <span>{{ $t("clientes.busqueda_contacto_lead.existe") }}</span>
      </span>
      <span v-else-if="resultadoBusqueda === false" class="d-inline-flex align-items-center gap-2 text-danger">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        <span>{{ $t("clientes.busqueda_contacto_lead.no_existe") }}</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import { toastError } from "@/.shared/services/notification-service";
import { useIntl } from "@/.shared/services/i18n";
import DxTextBox from "devextreme-vue/text-box";
import DxButton from "devextreme-vue/button";
import { ref, watch } from "vue";
import { secondaryButtonProps } from "@/.shared/helpers/button-helper";

const api = useApi();
const intl = useIntl();

const movilDisplay = ref("");
const movilInterno = ref<string | null>(null);
const resultadoBusqueda = ref<boolean | null>(null);

watch(movilDisplay, (value) => {
  movilInterno.value = value
    ? value.toUpperCase().replace(/ /g, "").replace(/^\+34/, "")
    : null;
  resultadoBusqueda.value = null;
});

function normalizarMovilParaApi(movil: string | null | undefined): string | null {
  if (!movil) {
    return null;
  }
  const telefono = movil.toUpperCase().replace(/ /g, "").replace(/^\+34/, "");
  if (!telefono) {
    return null;
  }
  return telefono.startsWith("+34") ? telefono : `+34${telefono}`;
}

const buscar = async () => {
  const telefonoNormalizado = normalizarMovilParaApi(movilInterno.value);
  if (!telefonoNormalizado || telefonoNormalizado.replace(/^\+34/, "").length < 9) {
    toastError(intl.i18n.t("clientes.busqueda_contacto_lead.telefono_invalido"));
    resultadoBusqueda.value = null;
    return;
  }
  try {
    const ok = await api.callStandardApi("existsContactoLeadByMobile", { showLoading: true }, { Telefono: telefonoNormalizado });
    resultadoBusqueda.value = !!ok;
  } catch {
    resultadoBusqueda.value = null;
    toastError(intl.i18n.t("clientes.busqueda_contacto_lead.error_consulta"));
  }
};
</script>
